import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { StoreChooserScreenProps } from 'home/stack/types'
import React, { useLayoutEffect } from 'react'
import { useScheduleContext } from 'schedule/schedule_context'
import { getDefaultSchedule, getSimilarSchedule } from 'schedule/schedules'
import { showHeaderButton } from 'shared/header/header_button'
import { useUser } from 'users/queries/detail'
import { useRecentStoresContext } from './context'
import { useStores } from './queries/list'
import { StoreChooserView } from './view'

export function StoreChooserScreen({
  navigation,
  route,
}: StoreChooserScreenProps) {
  const { data: user } = useUser()
  const { data: stores } = useStores(data => data.stores)
  const { activeStoreId, setActiveStoreId, setAllStoresSelected } =
    useRecentStoresContext()

  const { theme } = useTheme()
  const { schedule, setSchedule, availableSchedules } = useScheduleContext()

  useLayoutEffect(
    () =>
      showHeaderButton({
        navigation,
        theme,
        title: t('cancel'),
        onPress: async () => {
          navigation.goBack()
        },
      }),
    [navigation, theme]
  )

  return (
    <StoreChooserView
      stores={stores}
      activeStoreId={activeStoreId}
      onChoose={store => {
        setActiveStoreId?.(store.id)
        setAllStoresSelected?.(false)
        const similarSchedule =
          schedule && getSimilarSchedule(availableSchedules, schedule, store.id)
        setSchedule(
          similarSchedule ??
            getDefaultSchedule(
              user?.role ?? 'helper',
              availableSchedules,
              store.id
            )
        )
        navigation.goBack()
      }}
    />
  )
}
